export const firebaseConfig = {
  apiKey: "AIzaSyDSyb06xgqNoWQ1hyo_U9GfOTr0ehcLabg",
  authDomain: "daiyans-auto-repair.firebaseapp.com",
  projectId: "daiyans-auto-repair",
  storageBucket: "daiyans-auto-repair.appspot.com",
  messagingSenderId: "997103363775",
  appId: "1:997103363775:web:178253c115d69a2c15480a",
};
